import React, {useContext} from "react";
import { css } from "emotion";
import headerShaded from "../../assets/images/header-shadow2.png";
import TitleBlock from "../TitleBlock";
import EditButton from "./EditButton";
import MobileHeaderRow from "../header/MobileHeaderRow";
import {GlobalContext} from "../../context/GlobalState";

const ViewHeaderMobile = () => {
  const {currentSpotlight} = useContext(GlobalContext);

  return (
    <div className={container}>
      <MobileHeaderRow>
        <EditButton />
      </MobileHeaderRow>
      <TitleBlock
        title={currentSpotlight.name}
        subtitle="View, edit or make your Spotlight go live."
      />
    </div>
  );
};

export default ViewHeaderMobile;
const container = css`
  padding-bottom: 30px;
  background-position: center bottom;
  min-height: 230px;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-image: url(${headerShaded});
`;
